import React from 'react';
import { Card, Typography } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    root: {
        margin: '16px 0px',
        padding: 16
    },
    header: {
        fontSize: 24,
        marginTop: 16,
        lineHeight: '28px'
    }
}));

const ContentDescription = () => {
    const classes = useStyles();
    return (
        <Card className={classes.root}>
            <Typography component="h1" className={classes.header}>
                ListenOnRepeat Radio | Free Online Radio | Internet Radio
            </Typography>
            <Typography component="p">
                Listening to online radio stations is now easier than ever with ListenOnRepeat Radio. Find and play popular radio stations in your area for free. Beside just listening, you can now exclusively stream popular radio stations.
            </Typography>
            <br />
            <Typography component="p">
                You can listen to your favourite podcasts, shows, music, interviews and much more, all just a click away. Either it’s the world’s most listened to radio stations like - The Rush Limbaugh Show, The Sean Hannity Show and All Things Considered or Panel Game shows like “Wait Wait… Don’t Tell Me!”, ListenOnRepeat offers thousands of radio stations for you to discover.
            </Typography>
            <br />
            <Typography component="p">
                ListenOnRepeat filters and presents radio stations based on your location. For example, if you are a resident of the US, the most popular radio stations near you will be curated and presented to you. BBC Radio, Classic Rock Florida, 70s Hits Radio, Jazz FM and thousands of other online radio stations are for you to explore.
            </Typography>
            <br />
            <Typography component="p">
                Similarly, you can select the radio stations based upon your desired genre from Business, Sports, Comedy to Music Blues, Rock, Jazz and more. You can also create your favourite/history by hearting the radio stations and share it to your friends over social media.
            </Typography>
            <br />
            <Typography component="p">
                Sign-up to ListenOnRepeat Radio today and enjoy the unlimited access to thousands of radio stations worldwide for free!
            </Typography>
        </Card>
    );
}

export default ContentDescription;
